export const MAINCONTRACTADDRESS = "0x8d18154e1fC5de342A05ee7661AB4F22D9F57d2B"
